import { Provider } from '@angular/core';

import { runOnSportsWebInit } from '@frontend/sports/common/core/feature/app-init';

import { RunAfterLcpService } from './run-after-lcp.service';

export function provideRunAfterLcp(): Provider[] {
    return runOnSportsWebInit(RunAfterLcpService);
}
